import { createContext, useContext } from "react";
import { SliderProps } from "@/components/Slider/Slider.interface";

interface SliderContextType extends SliderProps {
  currentIndex?: number;
  columnGap?: number;
  slidesToShow?: number;
  isLastSlide?: boolean;
  totalSlides?: number;
  isCircular?: boolean;
}

export const SliderContext = createContext<SliderContextType | undefined>(undefined);

const useSliderContext = () => {
  const context = useContext(SliderContext);

  if (context === undefined) {
    throw new Error("useSliderContext must be used within a SliderProvider");
  }

  return context;
};

export default useSliderContext;
